angular.module('unergie.main')
.directive('landscapeSimplifiedForm', ($q, $timeout, ApiUser, AuthService, ErrorCatcher) => ({
    restrict: 'E',
    templateUrl: '/directives/landscape-simplified-form/landscape-simplified-form.html',
    scope: {
        idContract: '=',
        draft: '=',
        onLandscapeClose: '&',
    },
    link($scope, element, attrs) {
        $scope.hasSubmitted = false
        $scope.isSaving = false
        $scope.isDebug = false
        $scope.shouldCloseOnSave = true
        $scope.validated = {}
        $scope.landscape = {
            survey: {
                Q_housing_kind: undefined,
                Q_inhabited_area: undefined,
                Q_construct_date: undefined,
                Q_has_thermal_insulation: undefined,
                Q_housing_primary_use: undefined,
                Q_nb_inhabitant: undefined,
                Q_heating_kind: undefined,
                Q_heating_kind_detail: undefined,
                Q_celcius_day_comfort: undefined,
                Q_celcius_night_comfort: undefined,
            },
            equipments: {
                E_hotwater_electric_tank: false,
                E_hotwater_other: false,
                E_extra_electric_heating: false,
                E_dry_towel: false,
                E_electric_hotplate: false,
                E_electric_oven: false,
                E_dishwasher: false,
                E_washing_machine: false,
                E_dryer: false,
                E_washer_dryer: false,
                E_fridge: false,
                E_freezer: false,
                E_fridge_freezer: false,
                E_air_conditioner: false,
                E_pool: {
                    ED_electric_heating: undefined,
                    ED_month_per_year: undefined,
                },
                E_electric_car: {
                    ED_km_per_week: undefined,
                    ED_home_recharge_rate: undefined,
                },
            },
            extra: { // local state
                E_pool: false,
                E_electric_car: false,
                E_hotwater: undefined,
            },
        }

        $scope.Q_celcius_comfort_mapping = [
            { value: 17, color: 'temp-color-marine', tooltip: 'Économe' },
            { value: 18, color: 'temp-color-marine', tooltip: 'Normal' },
            { value: 19, color: 'temp-color-dark-pink', tooltip: 'Confortable' },
            { value: 20, color: 'temp-color-dark-pink', tooltip: 'Chaud' },
            { value: 21, color: 'temp-color-dark-pink', tooltip: 'Plus&nbsp;chaud' },
        ]

        const validator = {
            valid: () => ({ valid: true }),
            disabled: () => ({ valid: true, disabled: true }),
            mandatory: () => ({ valid: false, mandatory: true }),
            invalid: (msg) => ({ valid: false, msg }),
        }
        const validators = {
            Q_housing_kind: (landscape) => {
                if (_.isEmpty(landscape.survey.Q_housing_kind)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
            Q_inhabited_area: (landscape) => {
                if (!_.isNumber(landscape.survey.Q_inhabited_area)) {
                    return validator.mandatory()
                }
                if (landscape.survey.Q_inhabited_area < 1) {
                    return validator.invalid('La superficie doit être au minimum de 1 m<sup>2</sup>')
                }
                if (landscape.survey.Q_inhabited_area > 63154) {
                    return validator.invalid('La superficie doit être inférieure à celle du château de Versailles : 63154 m<sup>2</sup>')
                }
                return validator.valid()
            },
            Q_construct_date: (landscape) => {
                if (_.isEmpty(landscape.survey.Q_construct_date)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
            Q_has_thermal_insulation: (landscape) => {
                if (!_.isBoolean(landscape.survey.Q_has_thermal_insulation)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
            Q_nb_inhabitant: (landscape) => {
                if (!_.isNumber(landscape.survey.Q_nb_inhabitant)) {
                    return validator.mandatory()
                }
                if (landscape.survey.Q_nb_inhabitant <= 0) {
                    return validator.invalid('Le nombre d’occupants doit être supérieur à 0')
                }
                if (landscape.survey.Q_nb_inhabitant > 10) {
                    return validator.invalid('Le nombre d’occupants doit être inférieur ou égal à 10 (à défaut mettre 10)')
                }
                return validator.valid()
            },
            Q_housing_primary_use: (landscape) => {
                if (_.isEmpty(landscape.survey.Q_housing_primary_use)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
            Q_heating_kind: (landscape) => {
                if (_.isEmpty(landscape.survey.Q_heating_kind)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
            Q_heating_kind_detail: (landscape) => {
                if (landscape.survey.Q_heating_kind !== 'individual_heating') {
                    return validator.disabled()
                }
                if (_.isEmpty(landscape.survey.Q_heating_kind_detail)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
            E_extra_electric_heating: (landscape) => {
                const isCollectiveHeating = landscape.survey.Q_heating_kind === 'collective_heating'
                const isNonElectricHeating = ['gas_heating', 'other_heating'].indexOf(landscape.survey.Q_heating_kind_detail) > -1
                const isEnabled = isCollectiveHeating || isNonElectricHeating
                if (!isEnabled) {
                    return validator.disabled()
                }
                return validator.valid()
            },
            E_dry_towel: (landscape) => {
                const isCollectiveHeating = landscape.survey.Q_heating_kind === 'collective_heating'
                const isNonElectricHeating = ['gas_heating', 'other_heating'].indexOf(landscape.survey.Q_heating_kind_detail) > -1
                const isEnabled = isCollectiveHeating || isNonElectricHeating
                if (!isEnabled) {
                    return validator.disabled()
                }
                return validator.valid()
            },
            Q_celcius_day_comfort: (landscape) => {
                const isIndividualHeating = landscape.survey.Q_heating_kind === 'individual_heating'
                const isElectricHeating = ['mainly_electric_heating', 'exclusively_electric_heating'].indexOf(landscape.survey.Q_heating_kind_detail) > -1
                const isEnabled = isIndividualHeating && isElectricHeating
                if (!isEnabled) {
                    return validator.disabled()
                }
                if (!_.isNumber(landscape.survey.Q_celcius_day_comfort)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
            Q_celcius_night_comfort: (landscape) => {
                const isIndividualHeating = landscape.survey.Q_heating_kind === 'individual_heating'
                const isElectricHeating = ['mainly_electric_heating', 'exclusively_electric_heating'].indexOf(landscape.survey.Q_heating_kind_detail) > -1
                const isEnabled = isIndividualHeating && isElectricHeating
                if (!isEnabled) {
                    return validator.disabled()
                }
                if (!_.isNumber(landscape.survey.Q_celcius_night_comfort)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
            E_hotwater: (landscape) => {
                if (_.isEmpty(landscape.extra.E_hotwater)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
            E_pool: (landscape) => {
                if (landscape.survey.Q_housing_kind !== 'house') {
                    return validator.disabled()
                }
                return validator.valid()
            },
            ED_electric_heating: (landscape) => {
                if (landscape.survey.Q_housing_kind !== 'house' || landscape.extra.E_pool !== true) {
                    return validator.disabled()
                }
                if (landscape.extra.E_pool === true && !_.isBoolean(landscape.equipments.E_pool.ED_electric_heating)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
            ED_month_per_year: (landscape) => {
                if (landscape.survey.Q_housing_kind !== 'house' || landscape.extra.E_pool !== true) {
                    return validator.disabled()
                }
                if (landscape.extra.E_pool === true && !_.isNumber(landscape.equipments.E_pool.ED_month_per_year)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
            E_electric_car: (landscape) => {
                if (landscape.survey.Q_housing_kind !== 'house') {
                    return validator.disabled()
                }
                return validator.valid()
            },
            ED_km_per_week: (landscape) => {
                if (landscape.survey.Q_housing_kind !== 'house' || landscape.extra.E_electric_car !== true) {
                    return validator.disabled()
                }
                if (landscape.extra.E_electric_car === true && !_.isNumber(landscape.equipments.E_electric_car.ED_km_per_week)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
            ED_home_recharge_rate: (landscape) => {
                if (landscape.survey.Q_housing_kind !== 'house' || landscape.extra.E_electric_car !== true) {
                    return validator.disabled()
                }
                if (landscape.extra.E_electric_car === true && _.isEmpty(landscape.equipments.E_electric_car.ED_home_recharge_rate)) {
                    return validator.mandatory()
                }
                return validator.valid()
            },
        }

        const isE_poolDefined = (landscape) => {
            return _.isBoolean(_.get(landscape, 'equipments.E_pool.ED_electric_heating')) || _.isNumber(_.get(landscape, 'equipments.E_pool.ED_month_per_year'))
        }

        const isE_electric_carDefined = (landscape) => {
            return _.isNumber(_.get(landscape, 'equipments.E_electric_car.ED_km_per_week')) || !_.isEmpty(_.get(landscape, 'equipments.E_electric_car.ED_home_recharge_rate'))
        }

        const initFn = {
            survey: {
                Q_construct_date: (landscape) => {
                    const mapping = {
                        '~1950': '1950-1969',
                        '1950-1969': '1950-1969',
                        '1970-1989': '1990-2012',
                        '1990-2012': '1990-2012',
                        '~2013': '~2014',
                        '~2014': '~2014',
                    }
                    return { Q_construct_date: landscape.survey && _.get(mapping, landscape.survey.Q_construct_date, landscape.Q_construct_date) }
                },
            },
            equipments: {
                E_pool: (landscape) => {
                    if (!isE_poolDefined(landscape)) {
                        return {
                            E_pool: {
                                ED_electric_heating: undefined,
                                ED_month_per_year: undefined,
                            },
                        }
                    }
                    return {}
                },
                E_electric_car: (landscape) => {
                    if (!isE_electric_carDefined(landscape)) {
                        return {
                            E_electric_car: {
                                ED_km_per_week: undefined,
                                ED_home_recharge_rate: undefined,
                            },
                        }
                    }
                    return {}
                },
            },
            extra: {
                E_pool: (landscape) => ({ E_pool: isE_poolDefined(landscape) }),
                E_electric_car: (landscape) => ({ E_electric_car: isE_electric_carDefined(landscape) }),
                E_hotwater: (landscape) => {
                    if (landscape.equipments) {
                        if (landscape.equipments.E_hotwater_electric_tank === true) {
                            return { E_hotwater: 'E_hotwater_electric_tank' }
                        }
                        if (landscape.equipments.E_hotwater_other === true) {
                            return { E_hotwater: 'E_hotwater_other' }
                        }
                    }
                    return { E_hotwater: undefined }
                },
            },

        }

        const resetDisabledFieldFn = (field) => (landscape, validated) => (validated[field].disabled ? { [field]: undefined } : {})
        const extendsFn = {
            survey: {
                Q_heating_kind_detail: resetDisabledFieldFn('Q_heating_kind_detail'),
                Q_celcius_day_comfort: resetDisabledFieldFn('Q_celcius_day_comfort'),
                Q_celcius_night_comfort: resetDisabledFieldFn('Q_celcius_night_comfort'),
            },
            equipments: {
                E_extra_electric_heating: resetDisabledFieldFn('E_extra_electric_heating'),
                E_dry_towel: resetDisabledFieldFn('E_dry_towel'),
                E_cmv: (landscape) => ({
                    E_cmv: landscape.survey.Q_heating_kind === 'individual_heating' && ['mainly_electric_heating', 'exclusively_electric_heating'].indexOf(landscape.survey.Q_heating_kind_detail) > -1,
                }),
                E_television: () => ({ E_television: true }),
                E_iron: () => ({ E_iron: true }),
                E_pool: (landscape) =>
                    ((landscape.survey.Q_housing_kind !== 'house' || landscape.extra.E_pool !== true) ? { E_pool: undefined } : {}),
                E_electric_car: (landscape) =>
                    ((landscape.survey.Q_housing_kind !== 'house' || landscape.extra.E_electric_car !== true) ? { E_electric_car: undefined } : {}),
                E_hotwater_electric_tank: (landscape) => ({ E_hotwater_electric_tank: landscape.extra.E_hotwater === 'E_hotwater_electric_tank' }),
                E_hotwater_other: (landscape) => ({ E_hotwater_other: landscape.extra.E_hotwater === 'E_hotwater_other' }),
            },
        }

        $scope.isAdmin = () => AuthService.userHasGroup(['data-admin', 'data-reader'])
        $scope.toggleDebug = () => {
            $scope.isDebug = !$scope.isDebug
        }

        $scope.save = () => {
            $scope.hasSubmitted = true
            if (!$scope.validated.all) {
                $timeout(() => {
                    const containerOffsetTop = element.offset().top
                    const errorOffsetTop = element.find('.error, .border-error').first().offset().top
                    const offsetTop = Math.abs(containerOffsetTop - errorOffsetTop)
                    angular.element('.modal-open .modal').animate({ scrollTop: offsetTop }, 1000)
                }, 100)
                return
            }

            $scope.isSaving = true
            const { shouldCloseOnSave } = $scope

            // Override landscape state with defined rules before post
            const extendFields = (extendFieldsFn) => _.reduce(extendFieldsFn, (acc, fn) => _.assign(acc, fn($scope.landscape, $scope.validated)), {})
            const extendedLandscape = _.assign({}, $scope.landscape, {
                survey: _.assign({}, $scope.landscape.survey, extendFields(extendsFn.survey)),
                equipments: _.assign({}, $scope.landscape.equipments, extendFields(extendsFn.equipments)),
                extra: undefined, // erase the local value defined in $scope.landscape before submit
                version: 'v2-light',
            })

            ApiUser.postFullLandscape({ idContract: $scope.idContract, draft: $scope.draft }, extendedLandscape).$promise.then((result) => {
                if (shouldCloseOnSave) {
                    $scope.onLandscapeClose({
                        $event: _.assign({}, result, {
                            landscape: $scope.landscape,
                            landscapeDone: true,
                            landscapeVersion: 'v2-light',
                        }),
                    })
                }
            }).catch(ErrorCatcher)
            .finally(() => {
                $scope.isSaving = false
            })
        }

        const activate = () => {
            // Watcher on ALT keydown/keyup
            const onkeydown = angular.element(document).on('keydown.landscapeSimplifiedForm', ($event) => {
                const ALT = 18
                if ($event.keyCode === ALT) {
                    $scope.shouldCloseOnSave = false
                }
            })
            const onkeyup = angular.element(document).on('keyup.landscapeSimplifiedForm', ($event) => {
                const ALT = 18
                if ($event.keyCode === ALT) {
                    $scope.shouldCloseOnSave = true
                }
            })
            $scope.$on('$destroy', () => {
                onkeydown.off('keydown.landscapeSimplifiedForm')
                onkeyup.off('keyup.landscapeSimplifiedForm')
            })

            // Fetch server landscape
            ApiUser.searchLandscape({ idContract: $scope.idContract, draft: $scope.draft, format: 'survey' }).$promise.then((result) => {
                if (result && result.toJSON) {
                    const landscape = result.toJSON()
                    $scope.landscape = _.assign({}, landscape, {
                        survey: _.assign({}, landscape.survey, _.reduce(initFn.survey, (acc, fn) => _.assign(acc, fn(landscape)), {})),
                        equipments: _.assign({}, landscape.equipments, _.reduce(initFn.equipments, (acc, fn) => _.assign(acc, fn(landscape)), {})),
                        extra: _.reduce(initFn.extra, (acc, fn) => _.assign(acc, fn(landscape)), {}),
                    })
                }
            }).catch(ErrorCatcher)

            // Watch validation on each landscape change
            const onLandscapeChange = (landscape) => {
                const validated = _.mapValues(validators, (fn) => fn(landscape))
                $scope.validated = _.assign({}, validated, { all: _.every(_.map(validated, 'valid')) })
            }
            $scope.$watch('landscape', onLandscapeChange, true)
        }
        activate()
    },
}))
